"use strict";

PF.Field.Ip = class Ip extends PF.Field.String
	{
	static get options()
		{
		return {
			errors: {
				incorrect: (c) => `Некорректный IP адрес`,
			}
		};
		}

	init()
		{
		super.init();

		this.onChange('focus', () => this.displayValue = this.calcDisplayValue(this.model.get(this.key)));
		}

	bindInput()
		{
		this.on('model.change:' + this.key, () => {
			this.dom.input.value = this.calcDisplayValue(this.model.get(this.key, '', ''));
			this.validate(true);
			this.prevValue = this.model.get(this.key, '', '');
		}, true);
		this.on('dom.input.change:value', () => {
			this.dom.input.value = this.mediateDisplayValue(this.dom.input.value);
			this.model.setData(this.key, this.calcRealValue(this.dom.input.value));
		});
		}

	mediateDisplayValue(displayValue)
		{
		if (displayValue === null || displayValue === undefined)
			{
			return '';
			}
		let value = displayValue;
		value = value.replace(/[^0-9,.\s]+/g, '');
		value = value.replace(',', '.');
		value = value.replace('..', '.');
		value = value.replace(' ', '.');
		if(value[value.length-1]==='.')
			{
			if((value.match(/\./g) || []).length > 3)
				{
				value = value.substr(0, value.length - 1);
				}
			}
		if (value.match(/[0-9][0-9][0-9]$/) && this.prevValue.length < value.length && (value.match(/\./g) || []).length < 3)
			{
			value += '.';
			}
		if (value.match(/[0-9][0-9][0-9][0-9]$/))
			{
			value = value.substr(0, value.length - 1);
			}

		this.prevValue = value;
		return value;
		}


	calcDisplayValue(realValue)
		{
		if (realValue === null || realValue === undefined)
			{
			realValue = '';
			}

		return realValue;
		}

	calcRealValue(displayValue)
		{
		return displayValue;
		}

	validate(silent, error)
		{
		let value = this.model.get(this.key, null, null);

		if (value !== null)
			{
			let regExp = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/gm;
			if (!value.match(regExp))
				{
				return super.validate(silent, this.errors.incorrect);
				}
			}
		return super.validate(silent, error);
		}

	};


